<template>
  <div>
    <PageAllow controller="AvailableStockMaterials" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <v-card>
          <v-card-title>
            {{ $t("OverSellSetting.title") }}
            <v-spacer />
            <v-btn
              small
              dark
              color="print"
              class="px-2 me-2 mb-1"
              @click.stop="batchExport()"
              v-if="
                exportFlg &&
                $permission.permissionAllow('AvailableStockMaterials', 'export')
              "
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("OverSellSetting.batchExport") }}
            </v-btn>
            <v-btn
              small
              dark
              color="print"
              class="px-2 me-2 mb-1"
              @click.stop="Export()"
              v-if="
                exportFlg &&
                $permission.permissionAllow('AvailableStockMaterials', 'export')
              "
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("OverSellSetting.export") }}
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("OverSellSetting.defaultAvailableFlg.title") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group
                    row
                    v-model="defaultAvailableFlg"
                    dense
                    persistent-hint
                    :hint="$t('OverSellSetting.defaultAvailableFlg.hint')"
                  >
                    <v-radio
                      v-for="flg in defaultAvailableSettings"
                      :label="flg.text"
                      :key="flg.value"
                      :value="flg.value"
                    ></v-radio>
                  </v-radio-group>
                  <span
                    class="secondary--text text-subtitle-2 danger--text font-weight-bold"
                  >
                    {{ $t("OverSellSetting.defaultAvailableFlg.hint2") }}
                  </span>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("OverSellSetting.availableZeroNoDisplay.title") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="availableZeroNoDisplay" dense>
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('BusinessSetting.RadioField.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("OverSellSetting.modelSetting.title") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="overSellMode" dense>
                    <v-radio
                      v-for="model in modelSetting"
                      :label="model.text"
                      :key="model.value"
                      :value="model.value"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center" v-if="overSellMode == 2">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("OverSellSetting.Fields.stocks") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  <SearcherStock
                    v-model="stockSelected"
                    unclearable
                    noLabel
                    :stock-types="[0]"
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("OverSellSetting.newMaterialAutoAdd.title") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group
                    row
                    v-model="newMaterialAutoAdd"
                    dense
                    persistent-hint
                    :hint="$t('OverSellSetting.newMaterialAutoAdd.hint')"
                  >
                    <v-radio
                      v-for="flg in newMaterialAutoAddSettings"
                      :label="flg.text"
                      :key="flg.value"
                      :value="flg.value"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("OverSellSetting.overSellSetting.title") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="isEnable" dense>
                    <v-radio
                      v-for="model in overSellSetting"
                      :label="model.text"
                      :key="model.value"
                      :value="model.value"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("OverSellSetting.overSellType.title") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="type" dense>
                    <v-radio
                      v-for="model in overSellType"
                      :label="model.text"
                      :key="model.value"
                      :value="model.value"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center" v-if="type == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("OverSellSetting.default_safe_min") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-text-field
                    v-model="default_safe_min"
                    dense
                    single-line
                    type="number"
                    style="max-width: 150px"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>

        <v-card class="my-5">
          <v-card-title>
            {{ $t("OverSellSetting.StockMaterialsSetting") }}
            <span
              class="secondary--text text-subtitle-2 danger--text ml-3 mb-n2 font-weight-bold"
            >
              {{ $t("OverSellSetting.title_hint") }}
            </span>
            <v-spacer />
            <v-btn
              v-if="type == 3"
              small
              color="primary"
              class="ms-1"
              @click.stop="ImportDialog = true"
            >
              {{
                $t("Import.import", [
                  $t("OverSellSetting.Fields.material_saleable_num"),
                ])
              }}
            </v-btn>
            <v-btn
              small
              color="primary"
              class="ms-1"
              @click.stop="selectMaterialsDialog = true"
            >
              {{ $t("CRUD.newInfo", [$t("Material.ObjectName")]) }}
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row dense class="mx-5">
              <v-col cols="12" sm="12" md="4">
                <v-row dense align="center" class="pa-1">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.key_word"
                    @text="materialKeyword = $event"
                    :label="$t('Material.materialKeyword')"
                  />
                </v-row>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-row dense align="center" class="pa-1">
                  <SearcherMaterialCategory v-model="categorySelected" />
                </v-row>
              </v-col>
              <v-col cols="12" sm="12" md="4" align-self="center">
                <v-row dense align="center" class="search-controls">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        text
                        class="px-0 py-0 caption font-weight-bold grey--text"
                        color="primary"
                        @click.stop="onSearch()"
                      >
                        <v-icon small class="pe-1">fa-search</v-icon>
                        {{ $t("Search.search") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("Search.searchTip") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        text
                        class="caption font-weight-bold grey--text"
                        @click.stop="resetSearch()"
                      >
                        <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                        {{ $t("Search.reset") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("Search.resetTip") }}</span>
                  </v-tooltip>
                </v-row>
              </v-col>
            </v-row>

            <div class="mx-4 mb-4">
              <v-data-table
                :headers="headers"
                :items="materialItems"
                :loading="loading"
                multi-sort
                class="elevation-2 px-4 pt-1"
                :footer-props="$t('$config.footer-props')"
                mobile-breakpoint="800"
              >
                <template v-slot:body.prepend>
                  <tr class="d-none d-sm-table-row">
                    <td colspan="3"></td>
                    <td v-if="type == 3"></td>
                    <td align="center">
                      <v-text-field
                        v-if="type == 3"
                        :label="$t('OverSellSetting.Fields.applyToAll')"
                        hide-details
                        v-model="saleableNumAll"
                        type="number"
                        min="0"
                        class="my-1"
                        style="max-width: 100px; margin-left: auto"
                      />
                    </td>
                    <td></td>
                    <td class="align-center" v-if="type == 1 || type == 2">
                      <v-text-field
                        v-if="type == 1"
                        single-line
                        dense
                        hide-details
                        v-model="safeMinNumAll"
                        type="number"
                        min="0"
                        style="max-width: 100px; margin-left: auto"
                      />
                      <v-text-field
                        v-if="type == 2"
                        single-line
                        dense
                        hide-details
                        v-model="overSellPrecentageAll"
                        type="number"
                        min="0"
                        suffix="%"
                        style="max-width: 100px; margin-left: auto"
                      />
                    </td>
                    <td>
                      <v-btn
                        small
                        outlined
                        dark
                        color="danger"
                        class="px-2 me-2 mb-1"
                        @click.stop="
                          materials.length
                            ? (confirmRemoveMaterialsDialog = true)
                            : ''
                        "
                      >
                        {{ $t("OverSellSetting.Fields.removeAll") }}
                      </v-btn>
                    </td>
                  </tr>
                  <!-- 小屏 -->
                  <tr class="d-table-row d-sm-none">
                    <td class="v-data-table__mobile-row" v-if="type == 1">
                      <div class="v-data-table__mobile-row__header mt-1">
                        {{ $t("OverSellSetting.Fields.safe_min_num") }}
                      </div>
                      <div class="v-data-table__mobile-row__cell mt-1">
                        <v-text-field
                          single-line
                          dense
                          hide-details
                          v-model="safeMinNumAll"
                          type="number"
                          min="0"
                          style="max-width: 100px; margin-left: auto"
                        />
                      </div>
                    </td>
                    <td class="v-data-table__mobile-row" v-if="type == 2">
                      <div class="v-data-table__mobile-row__header mt-1">
                        {{ $t("OverSellSetting.Fields.over_sell_precentage") }}
                      </div>
                      <div class="v-data-table__mobile-row__cell mt-1">
                        <v-text-field
                          single-line
                          dense
                          hide-details
                          v-model="overSellPrecentageAll"
                          type="number"
                          min="0"
                          suffix="%"
                          style="max-width: 100px; margin-left: auto"
                        />
                      </div>
                    </td>
                    <td class="v-data-table__mobile-row" v-if="type == 3">
                      <div class="v-data-table__mobile-row__header mt-1">
                        {{ $t("OverSellSetting.Fields.saleable_num") }}
                      </div>
                      <div class="v-data-table__mobile-row__cell mt-1">
                        <v-text-field
                          single-line
                          dense
                          hide-details
                          v-model="saleableNumAll"
                          type="number"
                          min="0"
                          style="max-width: 100px; margin-left: auto"
                        />
                      </div>
                    </td>
                    <td class="v-data-table__mobile-row">
                      <div class="v-data-table__mobile-row__header mt-1">
                        {{ $t("TableHeaders.actions") }}
                      </div>
                      <div class="v-data-table__mobile-row__cell mt-1">
                        <v-btn
                          small
                          outlined
                          dark
                          color="danger"
                          class="px-2 me-2 mb-1"
                          @click.stop="removeAll()"
                        >
                          {{ $t("OverSellSetting.Fields.removeAll") }}
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:item.Description="{ item }">
                  <span>
                    {{
                      $t(
                        settings
                          ? settings.material_name_display_type == 1
                            ? "Material.materialName"
                                : settings.material_name_display_type == 4
                                    ? "Material.nameWithCode"
                            : "Material.materialNameWithCode"
                          : "Material.materialName",
                        [item.material_code, item.material_name]
                      )
                    }}
                  </span>
                  <br />
                  <span class="caption secondary--text">
                    {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
                    <span
                      v-if="
                        item.standard_name && item.standard_name.length > 12
                      "
                      :title="item.standard_name"
                      style="cursor: pointer"
                    >
                      {{ item.standard_name.slice(0, 12) + "......" }}
                    </span>
                    <span v-else>
                      {{ item.standard_name }}
                    </span>
                  </span>
                </template>
                <template v-slot:item.current_count="{ item }">
                  {{
                    $numberFormatter.formatWithDot(item.current_count, 2, true)
                  }}
                </template>
                <template v-slot:item.safe_min="{ item }">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="item.safe_min"
                    type="number"
                    min="0"
                    style="max-width: 100px; margin-left: auto"
                  />
                </template>
                <template v-slot:item.oversell_percent="{ item }">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="item.oversell_percent"
                    type="number"
                    min="0"
                    suffix="%"
                    style="max-width: 100px; margin-left: auto"
                  />
                </template>
                <template v-slot:item.available="{ item }">
                  <span>
                    {{
                      $numberFormatter.formatWithDot(
                        item.available_num,
                        2,
                        true
                      )
                    }}
                  </span>
                </template>
                <template v-slot:item.available_num="{ item }">
                  <v-text-field
                    v-if="type == 3"
                    single-line
                    dense
                    hide-details
                    v-model="item.manual_fixed_num"
                    type="number"
                    min="0"
                    style="max-width: 100px; margin-left: auto"
                  />
                  <span v-else>
                    {{
                      $numberFormatter.formatWithDot(
                        item.available_num,
                        2,
                        true
                      )
                    }}
                  </span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    small
                    text
                    class="danger--text pa-0"
                    @click.stop="
                      removeMaterialIds.push(item.material_id);
                      materials.splice(
                        materials.findIndex(
                          (detail) => item.material_id == detail.material_id
                        ),
                        1
                      );
                      save();
                    "
                  >
                    <v-icon>fa-times</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-sheet>
    </v-sheet>

    <v-sheet class="page-opts">
      <v-card class="mt-1">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("OverSellSetting.saveOverSellSettings") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <OverSellSelectMaterialsDialog
      v-model="selectMaterialsDialog"
      :fetchOptions="options"
      :type="type"
      :changed="materials"
      @confirm="
        addMaterials = $event;
        save();
      "
    />

    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('Material.ObjectName')"
      :options="options"
      @import="
        excelFile = $event;
        importExcel();
      "
    />

    <DialogAlert
      v-model="confirmRemoveMaterialsDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('OverSellSetting.confirmRemoveMaterialsMsg')"
      persistent
      useConfirm
      @confirm="removeAll()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import PageAllow from "@/components/PageAllow";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import DialogAlert from "@/components/plugins/DialogAlert";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import OverSellSelectMaterialsDialog from "./plugins/OverSellSelectMaterialsDialog";
import ImportExcelAlert from "./plugins/ImportExcelAlert";
import Settings from "@/api/settings";
import OverSellSettings from "@/api/over_sell_settings";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherStock,
    SearcherKeyword,
    SearcherMaterialCategory,
    OverSellSelectMaterialsDialog,
    ImportExcelAlert,
    DialogAlert,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("SettingNav.overSellSetting"),
        disabled: true,
        href: "/settings/over-sell-settings",
      },
    ],

    modelSetting() {
      return [
        {
          text: i18n.t("OverSellSetting.modelSetting.all_stock"),
          color: "primary",
          textColor: "white",
          value: 1,
        },
        {
          text: i18n.t("OverSellSetting.modelSetting.one_of_stock"),
          color: "primary",
          textColor: "white",
          value: 2,
        },
      ];
    },

    newMaterialAutoAddSettings() {
      return [
        {
          text: i18n.t("OverSellSetting.newMaterialAutoAdd.closed"),
          color: "primary",
          textColor: "white",
          value: 0,
        },
        {
          text: i18n.t("OverSellSetting.newMaterialAutoAdd.opened"),
          color: "primary",
          textColor: "white",
          value: 1,
        },
      ];
    },

    defaultAvailableSettings() {
      return [
        {
          text: i18n.t("OverSellSetting.defaultAvailableFlg.unlimited"),
          color: "primary",
          textColor: "white",
          value: 0,
        },
        {
          text: i18n.t("OverSellSetting.defaultAvailableFlg.sell_out"),
          color: "primary",
          textColor: "white",
          value: 1,
        },
      ];
    },

    overSellSetting() {
      return [
        {
          text: i18n.t("OverSellSetting.overSellSetting.on"),
          color: "primary",
          textColor: "white",
          value: 1,
        },
        {
          text: i18n.t("OverSellSetting.overSellSetting.off"),
          color: "primary",
          textColor: "white",
          value: 0,
        },
      ];
    },

    overSellType() {
      return [
        {
          text: i18n.t("OverSellSetting.overSellType.safe_min_num"),
          color: "primary",
          textColor: "white",
          value: 1,
        },
        {
          text: i18n.t("OverSellSetting.overSellType.over_sell_precentage"),
          color: "primary",
          textColor: "white",
          value: 2,
        },
        {
          text: i18n.t("OverSellSetting.overSellType.manual_setting"),
          color: "primary",
          textColor: "white",
          value: 3,
        },
      ];
    },

    headers() {
      var header = [
        {
          text: i18n.t("OverSellSetting.Fields.material_category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("OverSellSetting.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "Description",
        },
        {
          text: i18n.t("OverSellSetting.Fields.current_stock_num"),
          align: "end",
          sortable: false,
          value: "current_count",
        },
      ];

      if (this.type == 3) {
        header.push({
          text: i18n.t("OverSellSetting.Fields.available_num"),
          align: "end",
          sortable: false,
          value: "available",
        });
      }

      header.push(
        {
          text: i18n.t("OverSellSetting.Fields.saleable_num"),
          align: "end",
          sortable: false,
          value: "available_num",
        },
        {
          text: i18n.t("OverSellSetting.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        }
      );

      if (this.type == 1) {
        header.push({
          text: i18n.t("OverSellSetting.Fields.safe_min_num"),
          align: "end",
          sortable: false,
          value: "safe_min",
        });
      } else if (this.type == 2) {
        header.push({
          text: i18n.t("OverSellSetting.Fields.over_sell_precentage"),
          align: "end",
          sortable: false,
          value: "oversell_percent",
        });
      }

      header.push({
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      });

      return header;
    },

    materialItems() {
      return this.materials.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [
            detail.material_code,
            detail.material_name,
            detail.standard_name,
            detail.current_count,
          ]
        );

        return detail;
      });
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => ({
    setting: {},
    overSellMode: "",
    defaultAvailableFlg: "",
    availableZeroNoDisplay: 0,
    newMaterialAutoAdd: 1,
    isEnable: 0,
    default_safe_min: "",
    type: 1,
    stockSelected: null,
    options: {
      mode: 1,
      //default_available_flg: 0,
      stock_id: "",
      key_word: "",
      category_ids: "",
    },
    materialKeyword: "",
    categorySelected: null,
    materials: [],
    paging: {},
    safeMinNumAll: "",
    overSellPrecentageAll: "",
    saleableNumAll: "",
    selectMaterialsDialog: false,
    addMaterials: [],
    removeMaterialIds: [],
    confirmRemoveMaterialsDialog: false,
    exportFlg: 1,
    ImportDialog: false,
    excelFile: null,
  }),

  mounted() {
    this.getSettingsFromAPI();
  },

  methods: {
    resetSearch() {
      this.categorySelected = null;
      this.options = Object.assign({}, this.options, {
        key_word: "",
        category_ids: "",
      });
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        key_word: this.materialKeyword,
      });
    },
    getSettingsFromAPI() {
      Settings.fetch({
        keys: ["oversell_setting"],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.settings.oversell_setting) {
              this.setting = response.data.settings.oversell_setting;
              this.overSellMode = Number(
                response.data.settings.oversell_setting.mode
              );
              this.defaultAvailableFlg = Number(
                response.data.settings.oversell_setting.default_available_flg
              );
              this.availableZeroNoDisplay = Number(
                response.data.settings.oversell_setting
                  .available_zero_no_display
              );
              if (
                typeof this.setting.mode != "undefined" &&
                this.setting.mode != null
              ) {
                this.setting = Object.assign({}, this.setting, {
                  mode: Number(this.setting.mode),
                });
              }
              if (
                typeof this.setting.default_available_flg != "undefined" &&
                this.setting.default_available_flg != null
              ) {
                this.setting = Object.assign({}, this.setting, {
                  default_available_flg: Number(
                    this.setting.default_available_flg
                  ),
                });
              }
              //根据设置模式取其余各项设置值
              if (this.setting.mode == 1) {
                if (
                  typeof this.setting.is_enable != "undefined" &&
                  this.setting.is_enable != null
                ) {
                  this.exportFlg = Number(this.setting.is_enable);
                  this.isEnable = Number(this.setting.is_enable);
                  this.newMaterialAutoAdd = Number(
                    this.setting.new_material_auto_add
                  );
                }
                if (
                  typeof this.setting.type != "undefined" &&
                  this.setting.type != null
                ) {
                  this.type = Number(this.setting.type);
                }
                if (
                  typeof this.setting.default_safe_min != "undefined" &&
                  this.setting.default_safe_min != null
                ) {
                  this.default_safe_min = this.setting.default_safe_min;
                }
              }
              if (
                typeof this.setting.default_available_flg == "undefined" &&
                this.setting.default_available_flg == null
              ) {
                this.defaultAvailableFlg = 0;
              }
              if (
                typeof this.setting.available_zero_no_display == "undefined" &&
                this.setting.available_zero_no_display == null
              ) {
                this.availableZeroNoDisplay = 0;
              }
            } else {
              this.setting = {
                mode: 1,
                default_available_flg: 0,
                is_enable: 1,
                type: 1,
                default_safe_min: "",
              };
              this.overSellMode = 1;
              this.defaultAvailableFlg = 0;
              this.availableZeroNoDisplay = 0;
            }
          }
        }.bind(this)
      );
    },
    getStockMaterialsFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (this.overSellMode == 1) {
        delete options.stock_id;
        OverSellSettings.fetchAllStockMaterials(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materials = response.data.available_stock_materials;
              //如果全部修改值不为空，搜索重调接口后，要重新刷字段
              if (this.safeMinNumAll != "") {
                this.materials.map((material) => {
                  material.safe_min = this.safeMinNumAll;
                });
              }
              if (this.overSellPrecentageAll != "") {
                this.materials.map((material) => {
                  material.oversell_percent = this.overSellPrecentageAll;
                });
              }
              if (this.saleableNumAll != "") {
                this.materials.map((material) => {
                  material.manual_fixed_num = this.saleableNumAll;
                });
              }
              if (this.type == 3) {
                // 手动设置时 填充剩余可售数量
                this.materials.map((material) => {
                  material.manual_fixed_num =
                    material.manual_fixed_num != ""
                      ? material.available_num
                      : material.manual_fixed_num;
                });
              }
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
          }.bind(this)
        );
      } else if (this.overSellMode == 2 && options.stock_id) {
        OverSellSettings.fetchAllStockMaterials(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materials = response.data.available_stock_materials;
              //如果全部修改值不为空，搜索重调接口后，要重新刷字段
              if (this.safeMinNumAll != "") {
                this.materials.map((material) => {
                  material.safe_min = this.safeMinNumAll;
                });
              }
              if (this.overSellPrecentageAll != "") {
                this.materials.map((material) => {
                  material.oversell_percent = this.overSellPrecentageAll;
                });
              }
              if (this.saleableNumAll != "") {
                this.materials.map((material) => {
                  material.manual_fixed_num = this.saleableNumAll;
                });
              }
              if (this.type == 3) {
                // 手动设置时 填充剩余可售数量
                this.materials.map((material) => {
                  material.manual_fixed_num =
                    material.manual_fixed_num != ""
                      ? material.available_num
                      : material.manual_fixed_num;
                });
              }
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
          }.bind(this)
        );
      }
    },
    removeAll() {
      if (this.materials.length) {
        this.materials.forEach((m) => {
          this.removeMaterialIds.push(m.material_id);
        });
        this.materials = [];
        this.save();
      }
    },
    save() {
      this.$store.dispatch("fullscreenLoading");
      var submitData = {
        oversell_setting: {
          mode: this.overSellMode,
          default_available_flg: this.defaultAvailableFlg,
          available_zero_no_display: this.availableZeroNoDisplay,
          new_material_auto_add: this.newMaterialAutoAdd,
          is_enable: this.isEnable,
          type: this.type,
        },
        available_stock_materials: [],
      };
      if (this.type == 1) {
        submitData.oversell_setting.default_safe_min = this.default_safe_min;
      }
      if (this.overSellMode == 2 && this.stockSelected) {
        submitData = Object.assign({}, submitData, {
          oversell_setting: {
            stock_id: this.stockSelected.id,
            mode: this.overSellMode,
            default_available_flg: this.defaultAvailableFlg,
            available_zero_no_display: this.availableZeroNoDisplay,
            new_material_auto_add: this.newMaterialAutoAdd,
            is_enable: this.isEnable,
            type: this.type,
          },
        });
        if (this.type == 1) {
          submitData.oversell_setting.default_safe_min = this.default_safe_min;
        }
      }
      let available_stock_materials = [];
      if (this.addMaterials.length) {
        this.addMaterials.forEach((add) => {
          if (this.type == 1) {
            available_stock_materials.push({
              material_id: add.material_id,
              safe_min: this.default_safe_min,
            });
          } else if (this.type == 2) {
            available_stock_materials.push({
              material_id: add.material_id,
              oversell_percent: 95,
            });
          } else if (this.type == 3) {
            available_stock_materials.push({
              material_id: add.material_id,
              manual_fixed_num: "",
            });
          }
        });
      } else {
        this.materials.forEach((item) => {
          if (
            this.type == 1 &&
            (typeof item.safe_min == "number" || item.safe_min.length)
          ) {
            available_stock_materials.push({
              material_id: item.material_id,
              safe_min: item.safe_min,
            });
          } else if (
            this.type == 2 &&
            (typeof item.oversell_percent == "number" ||
              item.oversell_percent.length)
          ) {
            available_stock_materials.push({
              material_id: item.material_id,
              oversell_percent: item.oversell_percent,
            });
          } else if (this.type == 3) {
            available_stock_materials.push({
              material_id: item.material_id,
              manual_fixed_num: item.manual_fixed_num,
            });
          } else {
            this.removeMaterialIds.push(item.material_id);
          }
        });
      }

      submitData = Object.assign({}, submitData, {
        available_stock_materials: available_stock_materials,
        remove_material_ids: this.removeMaterialIds,
      });

      OverSellSettings.save(submitData)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("BusinessSetting.saveSuccess"));
              this.safeMinNumAll = "";
              this.overSellPrecentageAll = "";
              this.saleableNumAll = "";
              this.addMaterials = [];
              this.removeMaterialIds = [];
              this.getSettingsFromAPI();
              this.getStockMaterialsFromAPI();
              this.$store.dispatch("fullscreenLoadingStop");
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    Export() {
      var options = {
        key_word: this.options.key_word,
        category_ids: this.options.category_ids,
      };
      if (this.setting.mode == 2 && this.options.stock_id) {
        options = Object.assign({}, options, {
          stock_id: this.options.stock_id,
        });
      }
      OverSellSettings.exports(options);
    },
    batchExport() {
      OverSellSettings.batchExports();
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      OverSellSettings.imports(
        this.excelFile,
        this.options.mode,
        this.options.stock_id
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (this.materials.length) {
                this.materials.forEach((m) => {
                  this.removeMaterialIds.push(m.material_id);
                });
              }
              this.materials = [];
              this.materials = response.data.materials;
              this.ImportDialog = false;
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("Material.title")])
              );
              this.save();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        if (this.setting.mode) {
          this.getStockMaterialsFromAPI();
        }
      },
    },
    overSellMode: {
      immediate: true,
      deep: true,
      handler() {
        this.options.mode = this.overSellMode;
        if (this.overSellMode == 1) {
          this.stockSelected = null;
          this.newMaterialAutoAdd =
            this.setting.new_material_auto_add == 0
              ? this.setting.new_material_auto_add
              : 1;
          this.default_safe_min =
            this.setting.default_safe_min || this.setting.default_safe_min === 0
              ? this.setting.default_safe_min
              : null;
          this.isEnable =
            Number(this.setting.is_enable) == 1
              ? Number(this.setting.is_enable)
              : 0;
          this.setting = Object.assign({}, this.setting, {
            mode: 1,
          });
        } else if (this.overSellMode == 2 && this.stockSelected) {
          this.setting = Object.assign({}, this.setting, {
            mode: 2,
          });
          this.isEnable =
            Number(
              this.setting.setting_details[this.stockSelected.id].is_enable
            ) == 1
              ? Number(
                  this.setting.setting_details[this.stockSelected.id].is_enable
                )
              : 0;
          this.default_safe_min = this.setting.setting_details[
            this.stockSelected.id
          ].default_safe_min
            ? this.setting.setting_details[this.stockSelected.id]
                .default_safe_min
            : null;
        }
      },
    },
    stockSelected: {
      handler() {
        if (this.stockSelected) {
          this.options.stock_id = this.stockSelected.id;
          if (
            this.setting.mode == 2 &&
            this.setting.setting_details &&
            this.setting.setting_details[this.stockSelected.id]
          ) {
            this.newMaterialAutoAdd =
              this.setting.setting_details[this.stockSelected.id]
                .new_material_auto_add == 0
                ? this.setting.setting_details[this.stockSelected.id]
                    .new_material_auto_add
                : 1;
            this.isEnable = Number(
              this.setting.setting_details[this.stockSelected.id].is_enable
            );
            this.default_safe_min =
              this.setting.setting_details[
                this.stockSelected.id
              ].default_safe_min;
            this.type = Number(
              this.setting.setting_details[this.stockSelected.id].type
            );
            this.newMaterialAutoAdd = Number(
              this.setting.setting_details[this.stockSelected.id]
                .new_material_auto_add
            );
          } else {
            this.isEnable = 0;
            this.newMaterialAutoAdd = 1;
            this.default_safe_min = null;
          }
        }
        this.options.stock_id = this.stockSelected ? this.stockSelected.id : "";
      },
    },
    categorySelected: {
      handler() {
        this.options.category_ids = this.categorySelected
          ? this.categorySelected.id
          : "";
      },
    },
    safeMinNumAll: {
      deep: true,
      handler() {
        this.materials.map((material) => {
          material.safe_min = this.safeMinNumAll;
        });
      },
    },
    overSellPrecentageAll: {
      handler() {
        this.materials.map((material) => {
          material.oversell_percent = this.overSellPrecentageAll;
        });
      },
    },
    saleableNumAll: {
      handler() {
        this.materials.map((material) => {
          material.manual_fixed_num = this.saleableNumAll;
        });
      },
    },
  },
};
</script>